module.exports = __webpack_public_path__ + "static/media/checkmark.32dc38d9.svg";